import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { BlogMainImageCard } from './blog';
import * as routes from '../../routes';

// const Card = styled.div``;
const CategoryCard = styled.p`
  margin-top: 20px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 14px;
  text-transform: capitalize;
`;
const TitleCard = styled.h3`
  color: ${({ theme }) => theme.palette.text.primary};
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 600;
`;
const SummaryCard = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 1rem;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -ms-box-orient: vertical;
  box-orient: vertical;
  -webkit-line-clamp: 3;
  -moz-line-clamp: 3;
  -ms-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
`;

const BlogVerticalCard = ({ slug, img, category, title, summary }) => {
  return (
    <Link to={routes.blogPost.replace(':id', slug)}>
      <BlogMainImageCard>
        <img src={img} alt="" />
      </BlogMainImageCard>
      <CategoryCard>{category}</CategoryCard>
      <TitleCard>{title}</TitleCard>
      <SummaryCard>{summary}</SummaryCard>
    </Link>
  );
};

export default BlogVerticalCard;
